import { render, staticRenderFns } from "./applicationFinancialCompanyDetail.vue?vue&type=template&id=385facfe&scoped=true&"
import script from "./applicationFinancialCompanyDetail.vue?vue&type=script&lang=js&"
export * from "./applicationFinancialCompanyDetail.vue?vue&type=script&lang=js&"
import style0 from "./applicationFinancialCompanyDetail.vue?vue&type=style&index=0&id=385facfe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385facfe",
  null
  
)

export default component.exports